import {
  WalletData,
  Transaction,
  PaymentMethod,
  SpendingCategory,
  WalletLimit,
  AutoRule,
  WalletInsight,
  WalletNotification,
  WalletSecurity,
} from './types';

// Enhanced mock data for comprehensive wallet functionality
export const mockWalletData: WalletData = {
  totalBalance: 2847.5,
  availableBalance: 2647.5,
  pendingBalance: 500.0,
  heldBalance: 200.0,
  totalEarnings: 15420.75,
  totalSpent: 12573.25,
  creditLimit: 5000.0,
  mainCurrency: 'USD',
  accountStatus: 'active',
  riskLevel: 'low',
  lastActivity: '2024-08-20T14:30:00Z',
  currencies: [
    {
      code: 'USD',
      symbol: '$',
      balance: 2847.5,
      exchangeRate: 1,
      isMain: true,
      lastUpdated: '2024-08-20T14:30:00Z',
      volatilityRisk: 'low',
    },
    {
      code: 'EUR',
      symbol: '€',
      balance: 385.6,
      exchangeRate: 0.85,
      isMain: false,
      lastUpdated: '2024-08-20T14:25:00Z',
      volatilityRisk: 'low',
    },
    {
      code: 'GBP',
      symbol: '£',
      balance: 127.3,
      exchangeRate: 0.79,
      isMain: false,
      lastUpdated: '2024-08-20T14:25:00Z',
      volatilityRisk: 'low',
    },
  ],
};

export const mockTransactions: Transaction[] = [
  {
    id: 'TXN-2024-0891',
    type: 'deposit',
    amount: 1000.0,
    currency: 'USD',
    status: 'completed',
    description: 'Wallet Top-up via Credit Card',
    reference: 'REF-891-CC',
    timestamp: '2024-08-20T14:30:00Z',
    method: 'Credit Card (****1234)',
    category: 'Funding',
    tags: ['top-up', 'credit-card'],
    fee: 29.7,
    receipt: 'RCP-891-2024',
    riskScore: 15,
    ipAddress: '192.168.1.1',
    deviceInfo: 'Chrome/120.0 on macOS',
    geolocation: 'US',
  },
  {
    id: 'TXN-2024-0890',
    type: 'payment',
    amount: -450.0,
    currency: 'USD',
    status: 'completed',
    description: 'SEO Link Building Package',
    reference: 'ORD-2024-0847',
    timestamp: '2024-08-19T16:45:00Z',
    method: 'Wallet Balance',
    category: 'SEO Services',
    tags: ['seo', 'link-building'],
    relatedOrderId: 'ORD-2024-0847',
    riskScore: 8,
    merchantInfo: {
      name: 'Premium Link Solutions',
      category: 'SEO Services',
      website: 'premiumlinks.com',
      merchantId: 'MERCH-001',
    },
  },
  {
    id: 'TXN-2024-0889',
    type: 'refund',
    amount: 225.0,
    currency: 'USD',
    status: 'completed',
    description: 'Refund - Cancelled Order #ORD-2024-0832',
    reference: 'REF-889-RFD',
    timestamp: '2024-08-18T11:20:00Z',
    method: 'Wallet Credit',
    category: 'Refund',
    tags: ['refund', 'cancelled'],
    relatedOrderId: 'ORD-2024-0832',
    riskScore: 2,
  },
  {
    id: 'TXN-2024-0888',
    type: 'withdrawal',
    amount: -500.0,
    currency: 'USD',
    status: 'pending',
    description: 'Withdrawal to Bank Account',
    reference: 'WTH-888-BA',
    timestamp: '2024-08-17T09:15:00Z',
    method: 'Bank Transfer (****5678)',
    category: 'Withdrawal',
    tags: ['withdrawal', 'bank-transfer'],
    fee: 15.0,
    expectedCompletionDate: '2024-08-20T09:15:00Z',
    riskScore: 12,
  },
  {
    id: 'TXN-2024-0887',
    type: 'bonus',
    amount: 50.0,
    currency: 'USD',
    status: 'completed',
    description: 'Referral Bonus - New User Registration',
    reference: 'BON-887-REF',
    timestamp: '2024-08-16T13:30:00Z',
    method: 'Platform Credit',
    category: 'Bonus',
    tags: ['bonus', 'referral'],
    riskScore: 1,
  },
  {
    id: 'TXN-2024-0886',
    type: 'payment',
    amount: -1250.0,
    currency: 'USD',
    status: 'completed',
    description: 'Premium Content Writing Package',
    reference: 'ORD-2024-0845',
    timestamp: '2024-08-15T10:22:00Z',
    method: 'Wallet Balance',
    category: 'Content Writing',
    tags: ['content', 'writing', 'premium'],
    relatedOrderId: 'ORD-2024-0845',
    riskScore: 22,
    merchantInfo: {
      name: 'Elite Content Writers',
      category: 'Content Services',
      merchantId: 'MERCH-002',
    },
  },
  {
    id: 'TXN-2024-0885',
    type: 'payment',
    amount: -750.0,
    currency: 'USD',
    status: 'failed',
    description: 'Guest Post Publication Package',
    reference: 'ORD-2024-0844',
    timestamp: '2024-08-14T14:55:00Z',
    method: 'Credit Card (****9876)',
    category: 'Guest Posts',
    tags: ['guest-post', 'publication'],
    relatedOrderId: 'ORD-2024-0844',
    riskScore: 35,
    failureReason: 'Card declined - insufficient funds',
    merchantInfo: {
      name: 'Authority Publications',
      category: 'Publishing Services',
      merchantId: 'MERCH-003',
    },
  },
  {
    id: 'TXN-2024-0884',
    type: 'cashback',
    amount: 37.5,
    currency: 'USD',
    status: 'completed',
    description: 'Cashback - SEO Tools Subscription',
    reference: 'CB-884-SUB',
    timestamp: '2024-08-13T09:10:00Z',
    method: 'Platform Credit',
    category: 'Cashback',
    tags: ['cashback', 'subscription', 'tools'],
    riskScore: 1,
  },
  {
    id: 'TXN-2024-0883',
    type: 'transfer',
    amount: -300.0,
    currency: 'USD',
    status: 'completed',
    description: 'Transfer to Team Member - John Doe',
    reference: 'TRF-883-JD',
    timestamp: '2024-08-12T16:30:00Z',
    method: 'Internal Transfer',
    category: 'Transfer',
    tags: ['transfer', 'team'],
    recipient: 'john.doe@company.com',
    riskScore: 5,
  },
  {
    id: 'TXN-2024-0882',
    type: 'deposit',
    amount: 2000.0,
    currency: 'USD',
    status: 'completed',
    description: 'Wire Transfer Deposit',
    reference: 'WT-882-DEP',
    timestamp: '2024-08-10T11:45:00Z',
    method: 'Wire Transfer',
    category: 'Funding',
    tags: ['deposit', 'wire-transfer'],
    fee: 25.0,
    riskScore: 18,
    originalAmount: 2025.0,
    originalCurrency: 'USD',
  },
];

export const mockPaymentMethods: PaymentMethod[] = [
  {
    id: 'PM-001',
    type: 'credit_card',
    name: 'Visa Credit Card',
    details: '****1234 • Expires 12/26',
    isDefault: true,
    isExpired: false,
    expiryDate: '12/26',
    lastUsed: '2024-08-20T14:30:00Z',
    fees: 2.9,
    limits: {
      daily: 5000,
      monthly: 25000,
      transaction: 2000,
      remaining: { daily: 4150, monthly: 20000 },
      nextReset: { daily: '2024-08-21', monthly: '2024-09-01' },
    },
    verification: 'verified',
    country: 'US',
    currency: 'USD',
    provider: 'Visa',
    network: 'Credit',
    riskLevel: 'low',
    capabilities: ['deposit', 'subscription', 'recurring'],
    restrictions: [],
  },
  {
    id: 'PM-002',
    type: 'bank_account',
    name: 'Chase Checking Account',
    details: '****5678 • Chase Bank',
    isDefault: false,
    isExpired: false,
    lastUsed: '2024-08-15T09:00:00Z',
    fees: 0,
    limits: {
      daily: 10000,
      monthly: 100000,
      transaction: 5000,
      remaining: { daily: 9500, monthly: 95000 },
      nextReset: { daily: '2024-08-21', monthly: '2024-09-01' },
    },
    verification: 'verified',
    country: 'US',
    currency: 'USD',
    provider: 'Chase',
    riskLevel: 'low',
    capabilities: ['deposit', 'withdrawal', 'ach'],
    restrictions: [],
  },
  {
    id: 'PM-003',
    type: 'airwallex',
    name: 'Airwallex',
    details: 'USD · card ending •••• 4242',
    isDefault: false,
    isExpired: false,
    lastUsed: '2024-08-10T15:30:00Z',
    fees: 2.9,
    limits: {
      daily: 3000,
      monthly: 20000,
      transaction: 1500,
      remaining: { daily: 3000, monthly: 18500 },
      nextReset: { daily: '2024-08-21', monthly: '2024-09-01' },
    },
    verification: 'verified',
    country: 'US',
    currency: 'USD',
    provider: 'Airwallex',
    riskLevel: 'low',
    capabilities: ['deposit', 'withdrawal'],
    restrictions: [],
  },
  {
    id: 'PM-004',
    type: 'apple_pay',
    name: 'Apple Pay',
    details: 'iPhone 14 Pro • Touch ID',
    isDefault: false,
    isExpired: false,
    lastUsed: '2024-08-08T12:15:00Z',
    fees: 0,
    limits: {
      daily: 1000,
      monthly: 10000,
      transaction: 500,
      remaining: { daily: 1000, monthly: 9500 },
      nextReset: { daily: '2024-08-21', monthly: '2024-09-01' },
    },
    verification: 'verified',
    country: 'US',
    currency: 'USD',
    provider: 'Apple',
    riskLevel: 'low',
    capabilities: ['deposit', 'mobile'],
    restrictions: ['mobile_only'],
  },
];

export const mockSpendingCategories: SpendingCategory[] = [
  {
    name: 'SEO Services',
    amount: 1850.0,
    percentage: 42,
    color: '#4F46E5',
    transactions: 15,
    trend: 'up',
    trendPercentage: 12,
    budget: 2000,
    budgetPeriod: 'monthly',
    merchantCount: 5,
    averageTransaction: 123.33,
    subcategories: [
      {
        name: 'Link Building',
        amount: 1200.0,
        percentage: 65,
        transactionCount: 8,
      },
      {
        name: 'Keyword Research',
        amount: 350.0,
        percentage: 19,
        transactionCount: 4,
      },
      {
        name: 'Technical SEO',
        amount: 300.0,
        percentage: 16,
        transactionCount: 3,
      },
    ],
  },
  {
    name: 'Content Writing',
    amount: 1320.0,
    percentage: 30,
    color: '#059669',
    transactions: 8,
    trend: 'down',
    trendPercentage: 5,
    budget: 1500,
    budgetPeriod: 'monthly',
    merchantCount: 3,
    averageTransaction: 165.0,
    subcategories: [
      {
        name: 'Blog Posts',
        amount: 800.0,
        percentage: 61,
        transactionCount: 5,
      },
      {
        name: 'Product Descriptions',
        amount: 320.0,
        percentage: 24,
        transactionCount: 2,
      },
      { name: 'Web Copy', amount: 200.0, percentage: 15, transactionCount: 1 },
    ],
  },
  {
    name: 'Guest Posts',
    amount: 680.0,
    percentage: 16,
    color: '#DC2626',
    transactions: 12,
    trend: 'up',
    trendPercentage: 18,
    budget: 800,
    budgetPeriod: 'monthly',
    merchantCount: 7,
    averageTransaction: 56.67,
  },
  {
    name: 'Marketing Tools',
    amount: 420.0,
    percentage: 10,
    color: '#7C3AED',
    transactions: 6,
    trend: 'stable',
    trendPercentage: 2,
    budget: 500,
    budgetPeriod: 'monthly',
    merchantCount: 4,
    averageTransaction: 70.0,
  },
  {
    name: 'Other',
    amount: 130.0,
    percentage: 2,
    color: '#6B7280',
    transactions: 3,
    trend: 'down',
    trendPercentage: 8,
    merchantCount: 2,
    averageTransaction: 43.33,
  },
];

export const mockWalletLimits: WalletLimit[] = [
  {
    type: 'daily',
    current: 850,
    limit: 2000,
    resetDate: '2024-08-21',
    isApproachingLimit: false,
    canIncrease: true,
    increaseRequiresVerification: false,
    warningThreshold: 1800,
    currency: 'USD',
    lastModified: '2024-01-15T09:00:00Z',
  },
  {
    type: 'monthly',
    current: 4200,
    limit: 10000,
    resetDate: '2024-09-01',
    isApproachingLimit: false,
    canIncrease: true,
    increaseRequiresVerification: true,
    warningThreshold: 9000,
    currency: 'USD',
    lastModified: '2024-01-15T09:00:00Z',
  },
  {
    type: 'transaction',
    current: 0,
    limit: 5000,
    resetDate: 'N/A',
    isApproachingLimit: false,
    canIncrease: false,
    increaseRequiresVerification: true,
    warningThreshold: 4500,
    currency: 'USD',
    lastModified: '2024-01-15T09:00:00Z',
  },
  {
    type: 'withdrawal',
    current: 500,
    limit: 3000,
    resetDate: '2024-08-21',
    isApproachingLimit: false,
    canIncrease: true,
    increaseRequiresVerification: true,
    warningThreshold: 2700,
    currency: 'USD',
    lastModified: '2024-01-15T09:00:00Z',
  },
];

export const mockAutoRules: AutoRule[] = [
  {
    id: 'RULE-001',
    type: 'auto_fund',
    name: 'Auto-fund when balance is low',
    isActive: true,
    trigger: {
      condition: 'balance_below',
      value: 100,
      comparison: 'less_than',
    },
    action: {
      type: 'add_funds',
      amount: 500,
      method: 'PM-001',
      requiresConfirmation: false,
      autoApprove: true,
    },
    lastTriggered: '2024-08-10T08:30:00Z',
    timesTriggered: 3,
    createdDate: '2024-06-01T00:00:00Z',
    modifiedDate: '2024-08-01T00:00:00Z',
    priority: 1,
  },
  {
    id: 'RULE-002',
    type: 'spending_limit',
    name: 'Daily spending alert',
    isActive: true,
    trigger: {
      condition: 'daily_spending',
      value: 1500,
      comparison: 'greater_than',
      timeframe: 'daily',
    },
    action: {
      type: 'send_alert',
      message: 'Daily spending limit approaching',
      severity: 'medium',
      requiresConfirmation: true,
    },
    lastTriggered: '2024-08-18T16:45:00Z',
    timesTriggered: 2,
    createdDate: '2024-06-01T00:00:00Z',
    modifiedDate: '2024-07-15T00:00:00Z',
    priority: 2,
  },
  {
    id: 'RULE-003',
    type: 'suspicious_alert',
    name: 'Unusual transaction pattern',
    isActive: true,
    trigger: {
      condition: 'transaction_count',
      value: 10,
      comparison: 'greater_than',
      timeframe: 'hourly',
    },
    action: {
      type: 'security_alert',
      message: 'Unusual activity detected',
      severity: 'high',
      escalation: true,
      requiresConfirmation: true,
    },
    lastTriggered: undefined,
    timesTriggered: 0,
    createdDate: '2024-06-01T00:00:00Z',
    modifiedDate: '2024-06-01T00:00:00Z',
    priority: 3,
  },
];

export const mockWalletInsights: WalletInsight[] = [
  {
    id: 'INS-001',
    type: 'spending_pattern',
    title: 'SEO spending increased 12% this month',
    description:
      "You've spent $1,850 on SEO services, which is 12% more than last month. Consider setting a budget to track this category.",
    severity: 'info',
    actionable: true,
    actionText: 'Set Budget',
    actionUrl: '/wallet/budgets',
    timestamp: '2024-08-20T09:00:00Z',
    isRead: false,
    category: 'spending',
  },
  {
    id: 'INS-002',
    type: 'saving_opportunity',
    title: 'Switch to annual billing to save 15%',
    description:
      'Your monthly subscriptions total $420. Switching to annual billing could save you $630 per year.',
    severity: 'success',
    actionable: true,
    actionText: 'View Subscriptions',
    actionUrl: '/packages',
    timestamp: '2024-08-19T14:30:00Z',
    isRead: false,
    category: 'savings',
  },
  {
    id: 'INS-003',
    type: 'security_alert',
    title: 'New device login detected',
    description:
      "A new device accessed your wallet from Chrome on Windows. If this wasn't you, please secure your account.",
    severity: 'warning',
    actionable: true,
    actionText: 'Review Security',
    actionUrl: '/wallet/security',
    timestamp: '2024-08-18T11:22:00Z',
    isRead: true,
    category: 'security',
  },
];

export const mockWalletNotifications: WalletNotification[] = [
  {
    id: 'NOT-001',
    type: 'transaction',
    title: 'Payment Processed',
    message:
      'Your payment of $450.00 for SEO Link Building Package has been processed successfully.',
    timestamp: '2024-08-19T16:45:00Z',
    isRead: false,
    priority: 'medium',
    channel: 'in_app',
    data: { transactionId: 'TXN-2024-0890', amount: 450.0 },
  },
  {
    id: 'NOT-002',
    type: 'balance',
    title: 'Low Balance Alert',
    message:
      'Your wallet balance has dropped below $100. Consider adding funds to avoid payment delays.',
    timestamp: '2024-08-18T08:30:00Z',
    isRead: true,
    priority: 'high',
    channel: 'email',
    requiresAction: true,
    actionType: 'add_funds',
  },
  {
    id: 'NOT-003',
    type: 'security',
    title: 'Failed Login Attempt',
    message:
      'Someone tried to access your account with an incorrect password. Your account is secure.',
    timestamp: '2024-08-17T23:45:00Z',
    isRead: true,
    priority: 'urgent',
    channel: 'sms',
    data: { ipAddress: '203.0.113.0', location: 'Unknown' },
  },
];

export const mockWalletSecurity: WalletSecurity = {
  twoFactorEnabled: true,
  twoFactorMethod: '2fa_app',
  lastPasswordChange: '2024-06-15T09:30:00Z',
  suspiciousActivityDetected: false,
  securityScore: 85,
  riskFactors: ['Multiple recent logins', 'New device detected'],
  securityRecommendations: [
    'Enable biometric authentication',
    'Review trusted devices',
    'Update recovery email',
  ],
  loginAttempts: [
    {
      timestamp: '2024-08-20T14:30:00Z',
      ipAddress: '192.168.1.1',
      location: 'New York, US',
      device: 'Chrome on macOS',
      successful: true,
      riskScore: 15,
      blocked: false,
    },
    {
      timestamp: '2024-08-17T23:45:00Z',
      ipAddress: '203.0.113.0',
      location: 'Unknown',
      device: 'Firefox on Windows',
      successful: false,
      riskScore: 85,
      blocked: true,
      reason: 'Invalid credentials',
    },
  ],
  deviceTrust: [
    {
      deviceId: 'DEV-001',
      deviceName: 'MacBook Pro',
      firstSeen: '2024-01-15T00:00:00Z',
      lastSeen: '2024-08-20T14:30:00Z',
      trusted: true,
      riskLevel: 'low',
      location: 'New York, US',
      userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
    },
    {
      deviceId: 'DEV-002',
      deviceName: 'iPhone 14 Pro',
      firstSeen: '2024-02-01T00:00:00Z',
      lastSeen: '2024-08-19T18:22:00Z',
      trusted: true,
      riskLevel: 'low',
      location: 'New York, US',
      userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0 like Mac OS X) AppleWebKit/605.1.15',
    },
  ],
};

// Exchange rates for currency conversion
export const mockExchangeRates: Record<string, number> = {
  USD: 1.0,
  EUR: 0.85,
  GBP: 0.79,
  CAD: 1.35,
  AUD: 1.52,
  JPY: 110.0,
  CHF: 0.92,
  CNY: 7.25,
};

// Common transaction categories for filtering
export const transactionCategories = [
  'All Categories',
  'SEO Services',
  'Content Writing',
  'Guest Posts',
  'Marketing Tools',
  'Design Services',
  'Development',
  'Consulting',
  'Software & Tools',
  'Advertising',
  'Other',
];

// Transaction types for filtering
export const transactionTypes = [
  'All Types',
  'deposit',
  'withdrawal',
  'payment',
  'refund',
  'transfer',
  'fee',
  'bonus',
  'cashback',
  'commission',
];

// Transaction statuses for filtering
export const transactionStatuses = [
  'All Statuses',
  'completed',
  'pending',
  'failed',
  'cancelled',
  'processing',
  'on-hold',
  'disputed',
];

// Time ranges for analytics
export const timeRanges = [
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 30 days', value: '30d' },
  { label: 'Last 90 days', value: '90d' },
  { label: 'Last 6 months', value: '6m' },
  { label: 'Last year', value: '1y' },
  { label: 'All time', value: 'all' },
];

// Preset funding amounts
export const fundingPresets = [50, 100, 250, 500, 1000, 2500];

// Withdrawal processing times by method
export const withdrawalTimes: Record<string, string> = {
  bank_account: '2-3 business days',
  airwallex: '1-2 business days',
  wire_transfer: '1-2 business days',
  crypto: '10-60 minutes',
};
